import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';

import { DataComponent } from './component/data/data.component';
import { TextComponent } from './component/text/text.component';
import { EventCentreCPopDialogComponent } from './event-centre-c-pop-dialog.component';
import { TranslationIdMap } from './event-centre-c-pop-dialog.i18n';

@NgModule({
    declarations: [
        DataComponent,
        EventCentreCPopDialogComponent,
        TextComponent,
    ],
    imports: [
        CmpsButtonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CommonModule,
    ],
})
export class CmpsEventCentreCPopDialogModule {}
